import {required} from "vuelidate/lib/validators";  
const omalzeme = {
    data() { 
      return {   
        omalzemeData: { 
          Barkod: "",
          Karekod: "",
          Adi: "",
          Olcubirimi: "",
          Kayittarihi: "", 
          Aciklama:"",
          Image: null,
          Grupid: null,
          Deleted: false,
          }, 
          FormDataType:{
            Barkod:{FieldName:"Barkod",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Barkod'),FieldType:"text"},
            Karekod:{FieldName:"Karekod",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Karekod')},  
            Adi:{FieldName:"Adi",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Adi')},  
            Olcubirimi:{FieldName:"Olcubirimi",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Olcubirimi'),ComboDataArray:[]},  
            Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:this.$t('omalzeme.AddEdit.Aciklama')},
            Image:{FieldName:"Image",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Image')}, 
            Grupid:{FieldName:"Grupid",Field:"input",FieldTitle:this.$t('omalzeme.AddEdit.Grupid'),ComboDataArray:[]}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Barkod: { },  
        Karekod: {  }, 
        Adi: { required },  
        Olcubirimi: { required },
        Aciklama: {  },
        Grupid: {},
        Image: {}
      }
 
  },
  created(){
    this.ActionsSabitGet(201).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Olcubirimi.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    }); 
    var Page = {
      PageNumber: "1",
      PageSize: "999",
      PageDataSize: "1",
    }
    this.ActionsGet({"Service":"OMalzemeGrup", "Page": Page}).then((res) => {
      for(var i=0; i<res.Data.length; i++)
      {
        this.FormDataType.Grupid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Adi})
      } 
      });
  }
}
export default omalzeme